/** This Utils contains Utility functions that is used by Test Cases */

/* Checks if the environment is Cypress */
const isCypress = () => typeof window !== 'undefined' && window.IS_CYPRESS_ENV;

const getPurchaseDateFilterTestId = (momentDate) => {
    if (!isCypress()) return undefined;

    const year = momentDate.year();
    const month = String(momentDate.month() + 1).padStart(2, '0'); // month() is 0-based
    const dt = String(momentDate.date()).padStart(2, '0');
    return `date-range-picker-day-${year}${month}${dt}`;
};

/* Normalize formatter output: replace non-breaking spaces with regular spaces
   and normalize the Swiss/CLDR right single quotation mark (U+2019) to ASCII
   apostrophe so tests are independent of Node/ICU version differences. */
const replaceNbsp = (text) => text?.replace(/\u00A0/g, ' ').replace(/\u2019/g, "'");

export {
  getPurchaseDateFilterTestId,
  isCypress,
  replaceNbsp
};
